<template>
  <v-navigation-drawer v-model="drawer" :clipped="$vuetify.breakpoint.lgAndUp" app>
    <v-list dense>
      <v-list-tile @click.stop to="/admin/partners">
        <v-list-tile-action>
          <v-icon>domain</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>Credenciados</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
      <v-list-tile @click.stop to="/admin/clients">
        <v-list-tile-action>
          <v-icon>group</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>Associados</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
export default {
  props: ["value"],
  computed: {
    drawer: {
      set: function() {
        return this.value;
      },
      get: function() {
        return this.value;
      }
    }
  }
};
</script>
